import React from "react";
import {
  stage as stageEnum,
  getStageName,
  stockOnHandImg,
  getPublicFolderPath,
} from "../../../../utils";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  stageDateErrorHeader: { display: "flex", alignItems: "center" },
}));

export default function StageDateErrorHeader({ stage }) {
  const classes = useStyles();
  const stageName = getStageName(stage);
  const isStockOnHand = stageName === stageEnum.sellingStart.label;
  return (
    <div className={classes.stageDateErrorHeader}>
      Invalid date ({stageName}
      {isStockOnHand && (
        <img
          src={getPublicFolderPath(window.location.pathname) + stockOnHandImg}
          alt=""
        />
      )}
      )
    </div>
  );
}
